import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';
import App from './App';
import './index.css';
import './i18n'; // Initialize i18n
import { analytics } from './services/analytics'; // Initialize analytics

// Import data management helpers for development
import './utils/seedData';
import './utils/cleanupData';
import './utils/setup';

// Initialize Google Analytics 4
// TODO: Replace with your actual GA4 Measurement ID
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';
const IS_DEV = import.meta.env.DEV;

analytics.init(GA_MEASUREMENT_ID, IS_DEV); // Enable debug mode in development

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
